import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import image1 from "../../../../../Assets/gold-bars-background-free-photo.jpg";
import image2 from "../../../../../Assets/aboutUsBgImage.png";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import { adminUrl } from "../../../../../constants";
import ModalApproveButton from "../../../../../Components/ModalButton/HomeSectionButton/ModalApproveButton";

const AboutUsContent = ({ aboutDates, values, onClose, sectionNameForApproveAndReject }) => {




  const [responseData, setResponseData] = useState()

  console.log(values, "valuesssss")
  console.log(responseData, "responseDatattaatatatt")
  const TableId = useSelector((state) => state.Table.TableId);

  console.log(TableId, "TebleIddddd")

  const dispatch = useDispatch()

  useEffect(() => {
    console.log(TableId, "TebleIddddd111")

    if (TableId && !values) {
      console.log(TableId, "TebleIddddd222")

      const fetchData = async () => {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getAboutUsSectionById/${TableId}`,
        };
        const response = await dispatch(actions.GETABOUTUSSECTIONBYID(data1));

        console.log(response, "responseresponse")

        if (response?.payload?.message === "About Us section retrieved successfully.") {
          console.log("hiiii")

          setResponseData(response?.payload?.data)
          // setUploadedFile({
          //     fileUrl: response?.payload?.data.additional_data[0]?.banner,
          //     type: "img",
          //     progress: 100,
          // }
          // )
          // console.log(response?.payload?.data.additional_data[0]?.banner,"yhfuwrfrkjrw")
        }
      };
      fetchData();
    }

  }, []);


  const VisionData = values ? values?.cards?.map((data) => ({
    banner: data?.image?.fileUrl,
    title: data?.card_title,
    secondary_title: data?.cart_title_secondtext,
    content: data?.card_content
  })) : (responseData?.additional_data?.card_design?.map((data) => ({
    banner: data?.logo,
    title: data?.title,
    secondary_title: data?.cart_title_secondtext,
    content: data?.content
  })))



  console.log(VisionData, "valuesssss11")
  const VisionData1 = aboutDates?.[0]?.additional_data?.card_design || values?.cards || [
    {
      title: "Our",
      secondary_title: "Mission",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen bookLorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book ",
      banner: image1,
      reverse: false,
    },
    {
      title: "Our",
      secondary_title: "Mission",
      content:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages.",
      banner: image2,
      reverse: true,
    },
  ];

  return (
    <Box>
      <Box sx={{
        // padding: "2rem", 
        background: "white"
      }}>
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              paddingBottom: "5px",
              //  fontSize: "30px"
            }}
          >
            {/* <span style={{ color: "black", fontWeight: "800" }}>{stakeNowDates?.[0]?.sub_heading || "Default Sub-heading"}</span> */}
            {responseData?.heading || values?.title || "About Us"}
            {/* About Us */}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              paddingBottom: "5px",

              maxWidth: "800px",
              margin: "0 auto",
              textAlign: "center",
              color: "#b0aaaa",
            }}
          >
            {responseData?.content || values?.content ||
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."}
            {/* Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. */}
          </Typography>
        </Box>
        {VisionData?.map((item, index) => (
          <Grid
            container
            xs={12}
            key={index}
            // direction={item.reverse ? "row" : "row-reverse"}
            direction={index % 2 === 0 ? "row-reverse" : "row"}
            alignItems="center"
            sx={{ marginBottom: "3rem" }}
          >
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={`${adminUrl}${item?.banner}`}
                // src={item.banner}
                alt={item.title}
                sx={{
                  width: "100%",
                  borderRadius: "8px",
                  height: { xs: "250px", md: "330px" },
                  backgroundSize: "cover",
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h3"
                fontWeight={800}
                gutterBottom
                textAlign="center"
                color="black"
              >
                {item?.title}{" "}
                <span style={{ color: "#C38F51" }}>{item?.secondary_title}</span>
              </Typography>
              <Typography
                variant="body1"
                textAlign={{ xs: "justify", md: "justify" }}
                color="#747893"
                sx={{ px: { xs: "0", md: "20px" } }}
              >
                {item?.content}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Box>
      <ModalApproveButton approveStatus={responseData?.approval_status} values={values} onClose={onClose} sectionNameForApproveAndReject={sectionNameForApproveAndReject} />
    </Box>
  );
};

export default AboutUsContent;
